import {
  alimentationDialogues,
  alimentationInspections,
  alimentationScene,
} from './alimentation/alimentation.scene';
import { comptoirDialogues, comptoirInspections, comptoirScene } from './comptoir/comptoir.scene';
import {
  friandisesDialogues,
  friandisesInspections,
  friandisesScene,
} from './friandises/friandises.scene';
import { galerieDialogues, galerieScene } from './galerie/galerie.scene';
import { hallDialogues, hallInspections, hallScene } from './hall/hall.scene';
import { reserveDialogues, reserveInspections, reserveScene } from './reserve/reserve.scene';
import { registerDialogues } from '../interactions/dialogue';
import { registerEasterEggs, type EasterEggDefinition } from '../interactions/easter-egg';
import type { InspectContent } from '../interactions/inspect';
import type { SceneDefinition, SceneId } from './scene.types';

const registry: Record<SceneId, SceneDefinition> = {
  hall: hallScene,
  alimentation: alimentationScene,
  friandises: friandisesScene,
  comptoir: comptoirScene,
  reserve: reserveScene,
  galerie: galerieScene,
};

const inspections: Record<string, InspectContent> = {
  ...hallInspections,
  ...alimentationInspections,
  ...friandisesInspections,
  ...comptoirInspections,
  ...reserveInspections,
};

/** Easter eggs facultatifs : aucun n'est nécessaire pour terminer la visite (§13). */
export const EASTER_EGGS: EasterEggDefinition[] = [
  {
    id: 'egg.bell',
    streak: { hotspotId: 'hall.bell', count: 3 },
    message: 'La sonnette cède. Quelque part, un chien considère que c’est un signal.',
  },
  {
    id: 'egg.pawprints',
    sequence: ['hall.paw-2', 'hall.paw-1', 'hall.paw-3'],
    message: 'Les traces mènent au comptoir. Elles y menaient depuis le début.',
  },
  {
    id: 'egg.jar',
    streak: { hotspotId: 'friandises.jar', count: 3 },
    message: 'Le bocal s’ouvre tout seul. Nous refermons sans commenter.',
  },
  {
    id: 'egg.chain',
    sequence: ['friandises.mastication', 'friandises.bag', 'friandises.jar'],
    message: 'Tout le présentoir a bougé en même temps. Le rangement recommence demain.',
  },
  {
    id: 'egg.sleeping-dog',
    streak: { hotspotId: 'comptoir.dog', count: 2 },
    message: 'Le suspect dort toujours. Il tient un os qu’il n’a pas payé.',
  },
];

export function getScene(sceneId: SceneId): SceneDefinition {
  return registry[sceneId];
}

export function allScenes(): SceneDefinition[] {
  return Object.values(registry);
}

export function getInspection(id: string): InspectContent | undefined {
  return inspections[id];
}

/** Enregistre répliques et easter eggs de toutes les scènes. */
export function registerAllContent(): void {
  registerDialogues([
    ...hallDialogues,
    ...alimentationDialogues,
    ...friandisesDialogues,
    ...comptoirDialogues,
    ...reserveDialogues,
    ...galerieDialogues,
  ]);
  registerEasterEggs(EASTER_EGGS);
}
